module.exports = __webpack_public_path__ + "static/media/ic-secure-green.0dba8d9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-secure-green.svg
// module id = 661
// module chunks = 14